import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { RepositoryModal, Services, SafetyMeeting, ListItem } from '../../shared'
import { SafetyMeetingsComponent } from './meetings.component'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './meeting.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class SafetyMeetingComponent extends RepositoryModal<SafetyMeeting> implements OnInit {
    safetyTrainings: ListItem<string>[] = []
    constructor() {
        super()
    }
    ngOnInit() {}

    protected onInitialized() {
        let meetingsController = this.editOptions.initializeParams as SafetyMeetingsComponent
        this.safetyTrainings = meetingsController.safetyTrainings.map(x => new ListItem(x.code, x.description)).orderBy(x => x.display)
    }

    onBeforeSave() {
        this.target.code = ''
        return true
    }
}
